var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop"},React.createElement("g",{"id":"Home-2"},React.createElement("polygon",{"id":"Fill-1","points":"2.44 12.67 0.07 15 0 15.07 15.24 30 17.68 27.6 6.68 16.78 46 16.78 45.93 13.7 5.99 13.9 17.68 2.4 15.24 0 2.44 12.67","style":{"fillRule":"evenodd"}}))));
}

ArrowLeft.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 46 30"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
